<template>
  <GmbRow>
    <div
        :class="[
        'd-flex',
        { 'justify-content-center': isAlignedCenter },
        { 'justify-content-end': isAlignedRight },
      ]"
    >
      <GmbCopyright/>
    </div>
  </GmbRow>
</template>

<script>
import GmbCopyright from "@/widgets/Copyright";
import GmbRow from "@/widgets/Row";

export default {
  name: "GmbCopyrightRow",

  components: {
    GmbRow,
    GmbCopyright,
  },

  props: {
    isAlignedCenter: Boolean,
    isAlignedRight: Boolean,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
